document.addEventListener("DOMContentLoaded", function () {
    // Define the SVG image URLs
    const svgIcons = [
        "https://cdn.shopify.com/s/files/1/0738/2636/9791/files/1_4e2e838b-d311-43eb-a3d3-aa2dc9646164.svg?v=1739217402",
        "https://cdn.shopify.com/s/files/1/0738/2636/9791/files/2_8bcc08ea-f856-497e-a8cc-43283f5debb1.svg?v=1739217402",
        "https://cdn.shopify.com/s/files/1/0738/2636/9791/files/3_900728c8-3ed3-4cd8-83de-998d1a43bcb8.svg?v=1739217402"
    ];

    // Select the specific block-widget using its full class
    const blockWidget = document.querySelector(".block-widget.block-menu.block-72bcf5ea-e853-4b67-a838-7285722036b5");
    
    if (blockWidget) {
        // Select all menu item links inside this widget
        blockWidget.querySelectorAll(".menu-list .menu-item a").forEach((link, index) => {
            // Remove existing <img> if it exists
            const existingImg = link.querySelector("img");
            if (existingImg) {
                existingImg.remove();
            }

            // Remove existing <i> (FontAwesome icons) if it exists
            const existingIcon = link.querySelector("i");
            if (existingIcon) {
                existingIcon.remove();
            }

            // Create a new img element for the SVG icon
            const img = document.createElement("img");
            img.src = svgIcons[index]; // Assign the correct SVG URL
            img.alt = "icon"; // Add alt attribute
            img.style.width = "14px"; // Set width
            img.style.height = "14px"; // Set height
            img.style.marginRight = "8px"; // Add spacing

            // Insert the new image at the beginning of the link
            link.prepend(img);
        });
    }
});
